module.exports = require('./lib/reading-time');
